const GET_DETAIL_SEASON_BY_ID = 'GET_DETAIL_SEASON_BY_ID'
const GET_DETAIL_SEASON_BY_ID_SUCCESS = 'GET_DETAIL_SEASON_BY_ID_SUCCESS'

const PUT_SEASON = 'PUT_SEASON'
const PUT_SEASON_SUCCESS = 'PUT_SEASON_SUCCESS'

const POST_SEASON = 'POST_SEASON'
const POST_SEASON_SUCCESS = 'POST_SEASON_SUCCESS'

const GET_SEASON_PAGES = 'GET_SEASON_PAGES'
const GET_SEASON_PAGES_SUCCESS = 'GET_SEASON_PAGES_SUCCESS'

const GET_SEASON_LIST = 'GET_SEASON_LIST'
const GET_SEASON_LIST_SUCCESS = 'GET_SEASON_LIST_SUCCESS'


const SeasonType = {
  GET_DETAIL_SEASON_BY_ID,
  GET_DETAIL_SEASON_BY_ID_SUCCESS,

  PUT_SEASON,
  PUT_SEASON_SUCCESS,

  POST_SEASON,
  POST_SEASON_SUCCESS,

  GET_SEASON_PAGES,
  GET_SEASON_PAGES_SUCCESS,

  GET_SEASON_LIST,
  GET_SEASON_LIST_SUCCESS

}

export default SeasonType
